import React from "react";
import Configure from "../../components/configure/configure";
import useTitle from "../../hooks/useTitle";
import { isLoggedIn } from "../../utils/auth";

export default function ConfigurePage() {
    useTitle("Configure");

    if (!isLoggedIn()) {
        window.location = '/';;
        return null;
    }

    return <Configure></Configure>;
}
